export class ObjectId {
  constructor(public value: string) {
  }
}
